<template lang="">
  <div class="cardContent">
    <el-tabs v-model="time" @tab-click="handleClick">
      <el-tab-pane label="今天" name="1"></el-tab-pane>
      <el-tab-pane label="最近三天" name="3"></el-tab-pane>
      <el-tab-pane label="最近一周" name="7"></el-tab-pane>
    </el-tabs>
    <div class="selectBtn">
      <div
        :class="selectOn == index ? 'selectBtnList selectOn' : 'selectBtnList'"
        v-for="(item, index) in select"
        :key="index"
        @click="selectClick(index)"
      >
        <img :src="item.img" alt="" />
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="chart" ref="sqLineChart" />
  </div>
</template>

<script>
import { loadSqChart } from "../chart/sqChartData";
import { getScreenV2FindWlwSoilGetLSSJ } from "@/api/zhwl";
export default {
  data() {
    return {
      time: "1",
      selectOn: 0,
      select: [
        {
          name: "温度",
          img: ""
        },
        {
          name: "湿度",
          img: ""
        }
      ],
      endTime: this.$formatDate(new Date(), "yyyy-MM-dd hh:mm:ss"),
      startTime: this.$formatDate(
        new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000),
        "yyyy-MM-dd hh:mm:ss"
      )
    };
  },
  mounted() {
    this.sqchart = this.$echarts.init(this.$refs.sqLineChart);
    this.loadData();
    window.addEventListener("resize", () => {
      this.sqchart.resize();
    });
  },
  methods: {
    handleClick(val) {
      if (val.name === "3") {
        this.startTime = this.$formatDate(
          new Date(new Date().getTime() - 3 * 24 * 60 * 60 * 1000),
          "yyyy-MM-dd hh:mm:ss"
        );
      } else if (val.name === "7") {
        this.startTime = this.$formatDate(
          new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
          "yyyy-MM-dd hh:mm:ss"
        );
      } else {
        this.startTime = this.$formatDate(
          new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000),
          "yyyy-MM-dd hh:mm:ss"
        );
      }
      this.loadData();
    },
    selectClick(index) {
      this.selectOn = index;
      this.loadData();
    },
    loadData() {
      getScreenV2FindWlwSoilGetLSSJ({
        // deviceNo: this.graphic.code,
        wlwSoilId: "60b29c6b3a0f482fbba7c4485327ec2f",
        startTime: this.startTime,
        endTime: this.endTime,
        orderTime: "asc"
      }).then(res => {
        if (res.code === 200) {
          let data = [];
          let unit = "";
          if (this.selectOn === 0) {
            for (var i = 0; i < res.data.length; i++) {
              data.push({
                date: res.data[i].date,
                value10: res.data[i].temp10,
                value20: res.data[i].temp20,
                value30: res.data[i].temp30
              });
            }
            unit = "℃";
          } else if (this.selectOn === 1) {
            for (i = 0; i < res.data.length; i++) {
              data.push({
                date: res.data[i].date,
                value10: res.data[i].humi10,
                value20: res.data[i].humi20,
                value30: res.data[i].humi30
              });
            }
            unit = "%";
          }
          let dtype = "yyyy-MM-dd";
          if (this.time == "1") {
            dtype = "hh:mm";
          }
          loadSqChart(this.sqchart, data, unit, dtype);
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.cardContent
  position relative
  height 100%
  padding 0px 12px
  box-sizing border-box
  .chart
    height 100%
/deep/.el-tabs__header
  margin 0
/deep/ .el-tabs
  padding-left 10px
  marign-bottom 4px
  box-sizing border-border-box
/deep/.el-tabs__item
  height 30px
  line-height 30px
  color #fff
  font-size 13px

/deep/.el-tabs__item.is-active
  color rgb(243, 208, 19)

/deep/.el-tabs__nav-wrap::after
  height 0

/deep/.el-tabs__active-bar
  background rgb(243, 208, 19)

.selectBtn
  position absolute
  top 0px
  right 26px
  display flex
  flex-wrap wrap
  justify-content center
  z-index 1

.selectBtnList
  padding 3px
  cursor pointer

.selectBtnList span
  color #fff

.selectOn span
  color rgb(14, 156, 255) !important
</style>
